import LoadableMonacoEditor from 'js/components/elements/editors/monaco/LoadableMonacoEditor';
import Constants from 'js/Constants';
import { has } from 'lodash';
import React, { useEffect, useRef } from 'react';
import {
  DEFAULT_CODE,
  DEFAULT_CODE_FLEX_FLOW,
} from 'new/components/flows/shared/customProcessor/CustomProcessorConstants';
import { useDebouncedCallback } from 'new/hooks/useDebouncedCallback';

export type EnterCustomProcessorProps = {
  isFlexFlow?: boolean;
  sourceConfig: Record<string, unknown>;
  onSourceConfigChanged: (config: Record<string, unknown>) => void;
};

const EnterCustomProcessor = (props: EnterCustomProcessorProps) => {
  const { sourceConfig, onSourceConfigChanged, isFlexFlow } = props;

  const sourceConfigRef = useRef(sourceConfig);
  sourceConfigRef.current = sourceConfig;

  const onCodeChanged = useDebouncedCallback(
    (code: string) => {
      const latestSourceConfig = sourceConfigRef.current;
      const updatedSourceConfig = {
        ...latestSourceConfig,
        customProcessorCode: code,
      };
      onSourceConfigChanged(updatedSourceConfig);
    },
    [onSourceConfigChanged],
    300,
  );

  // @Init
  useEffect(() => {
    if (has(sourceConfig, 'customProcessorCode')) return;

    const initialProcessorCode = isFlexFlow ? DEFAULT_CODE_FLEX_FLOW : DEFAULT_CODE;
    onCodeChanged(initialProcessorCode);
  }, []);

  const monacoEditorValue =
    typeof sourceConfig?.customProcessorCode === 'string' ? sourceConfig.customProcessorCode : '';

  return (
    <LoadableMonacoEditor
      language={Constants.CodeLanguages.PYTHON}
      theme="dark"
      height={400}
      value={monacoEditorValue}
      onChange={onCodeChanged}
    />
  );
};

export default EnterCustomProcessor;
